import { initializeApp } from "firebase/app"
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

export const storage = getStorage(app);
export const auth = getAuth(app)
export const db = getFirestore(app)

// Function to log in the user
// const loginUser = (email, password) => {
//   signInWithEmailAndPassword(auth, email, password)
//     .then((userCredential) => {
//       // console.log("User logged in successfully:", userCredential.user)
//     })
//     .catch((error) => {
//       console.error("Error logging in:", error.message)
//     })
// }

// Check authentication status
// onAuthStateChanged(auth, (user) => {
//   if (user) {
//     // console.log("User is logged in:", user)
//     // Now you can safely perform any Firestore operations here
//   } else {
//     console.log("User is not logged in.")
//     // Optional: Automatically attempt to log in or redirect to login page
//     loginUser(process.env.REACT_APP_LOGIN_EMAIL, process.env.REACT_APP_LOGIN_PASSWORD)
//   }
// })

// Uncomment and call `loginUser` function with valid credentials to log in the user
// loginUser(process.env.REACT_APP_LOGIN_EMAIL, process.env.REACT_APP_LOGIN_PASSWORD)
